import * as d3 from 'd3';
import { Element } from 'react-faux-dom';

const Resize = (data) => {
  let width = data;
  let num = 0;
  if (window.screen.width >= 1850) {
    width = 1000;
    num = 3;
  } else if (window.screen.width >= 1600 && window.screen.width < 1850) {
    width = 800;
    num = 1;
  } else if (window.screen.width >= 1400 && window.screen.width < 1600) {
    width = 700;
    num = -1;
  }
  return {
    width,
    num,
  };
};

const StackedBarChart = (props) => {
  // const customStyle = { position: 'relative' };
  const size = Resize(props.width);

  const x = d3.scaleBand().rangeRound([0, size.width]).padding(props.rect.padding);

  const xAxis = d3.axisBottom(x);

  const y = d3.scaleLinear().domain([props.rect.maxValue, 0]).range([0, 455]);

  const yAxis = d3.axisLeft(y); //.tickFormat(d3.format(".0"));

  const div = new Element('div');
  const svg = d3
    .select(div)
    .append('svg')
    .attr('width', '100%')
    .attr('position', 'relative')
    .attr('viewBox', `0 0 730 520`)
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .attr('height', props.height + props.margin.top + props.margin.bottom - 20)
    .append('g')
    .attr('transform', 'translate(' + props.margin.left + ',' + props.margin.top + ')');

  const xTitle = [];
  for (const [key] of Object.entries(props.data[0])) {
    if (`${key}` !== 'date' && `${key}` !== 'refDate' && `${key}` !== 'totalSummary') {
      xTitle.push(`${key}`);
    }
  }

  props.data.forEach((d, i) => {
    let y0 = 0;
    d.rates = xTitle.map((name) => {
      return {
        name: name,
        y0: y0,
        y1: (y0 += d[name].value),
        hoverTxt: d[name].hoverTxt,
        nameTxt: d[name].nameTxt,
        total: d.totalSummary ? d.totalSummary : 0,
        index: i,
      };
    });
  });

  x.domain(props.data.map((d) => d.date));

  svg
    .append('g')
    .attr('class', 'x axis')
    .attr('transform', 'translate(0,' + props.height + ')')
    .call(xAxis);

  svg.append('g').attr('class', 'y axis').call(yAxis);

  // Add X axis label:
  svg
    .append('text')
    .attr('text-anchor', 'end')
    .attr('x', size.width / 2)
    .attr('y', props.height + props.margin.top + 20)
    .style('fill', '#0f0f0f')
    .text(props.lableX);

  // Y axis label:
  svg
    .append('text')
    .attr('text-anchor', 'end')
    .attr('transform', 'rotate(-90)')
    .attr('y', -props.margin.left + 20)
    .attr('x', -props.margin.top - props.height / 2 + 50)
    .style('fill', '#0f0f0f')
    .text(props.unit);

  const date = svg
    .selectAll('.date')
    .data(props.data)
    .enter()
    .append('g')
    .attr('class', 'date')
    .attr('transform', (d) => {
      return 'translate(' + (x(d.date) + size.num) + ',0)';
    });

  const bars = date
    .selectAll('rect')
    .data((d) => d.rates)
    .enter()
    .append('g');

  bars
    .append('rect')
    .attr('width', /*x.rangeBand()*/ props.rect.width)
    .attr('y', (d) => y(d.y1))
    .attr('height', (d) => y(d.y0) - y(d.y1))
    .style('fill', (d) => props.color[d.name])
    .on('mouseover', function (d, value) {
      d3.select('.chart-tooltip').style('display', null).html(`${value.nameTxt}: ${value.hoverTxt} ${props.unit}`);
    })
    .on('mousemove', function (d, value) {
      d3.select('.chart-tooltip')
        .style('top', d.pageY - 10 + 'px')
        .style('left', d.pageX + 10 + 'px');
    })
    .on('mouseout', function () {
      d3.select('.chart-tooltip').style('display', 'none');
    });

  bars
    .transition()
    .ease(d3.easeCubic)
    .duration(1000)
    .attr('height', (d) => y(d.y0) - y(d.y1))
    .attr('y', (d) => y(d.y1));

  bars
    .append('text')
    .attr('y', (d) => y(d.y1) - 10)
    .attr('x', props.viewType === 'month' ? 3 : 9)
    .text(function (d, i) {
      const lengthOfData = props.data[d.index].rates.length - 1;
      return lengthOfData === i ? d.total : '';
    });

  // tooltip
  d3.select('body')
    .append('div')
    .classed('chart-tooltip', true)
    .style('display', 'none')
    .style('position', 'absolute')
    .style('z-index', '1500')
    .style('padding', '15px')
    .style('background', '#FFFFFF')
    .style('border-radius', '5px')
    .style('color', '#858383')
    .style(
      'box-shadow',
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    )
    .text('a simple tooltip');

  return div.toReact();
};

export default StackedBarChart;
